export default "__VITE_ASSET__qcPAfWOk__"